import type { Currency } from 'types/entities/currency';

let currencies: Currency[] = [];

export const setCurrencies = (value: Currency[]) => {
  currencies = value;
};

export const getCurrencies = () => currencies;
